import { defineStore } from 'pinia'
import { authExchangeApi, logoutApi } from '~/api/system'

export const useMySystemStore = defineStore('mySystemStore', {
  state: () => ({
    appId: getAppId(),
    token: getToken(),
    regChannel: '',
    headerIsWhite: false,
    showPolicyBubble: true,
    language: 'en-US',
    showHeaderPopup: false,
    noHeader: false,
    isAPP: false,
    terminalType: 'H5',
    proxyApi: 'https://cloudapi.jctrans.com',
    targetPageCode: '',
  }),
  getters: {
    appid: (state) => {
      return state.appId
    },
    userIsLogin: (state) => {
      const userStore = useMyUserStore()
      return !!state.token && userStore.userId !== null
    },
  },
  actions: {
    // 用于插件或初始化时从 cookie 同步 token
    initTokenFromCookie() {
      try {
        const t = getToken() ?? ''
        if (t) {
          this.token = t
        } else {
          this.token = ''
        }
      } catch (e) {
        // 在极端情况下（不在 Nuxt 上下文）useCookie 可能出错，安全兜底
        this.token = ''
      }
    },
    changeIsApp(flag: boolean) {
      this.isAPP = flag
    },
    changeAppConfig(data: any) {
      this.isAPP = true
      this.terminalType = data?.appTerminalType || 'APP'
      this.changeNoHeader(false)
      // 加这个逻辑是为了防止他在app切换账号，回来之后刷新页面无法同步刷新账号信息
      const { resetUserCompInfo } = useMyUserStore()
      const { closeSearchDialog } = useSearchTimeStore()
      closeSearchDialog()
      resetUserCompInfo()
      console.log('🍉 ~ system.ts:39 ~ changeAppConfig ~ data:', data)
      if (data?.appToken) {
        setToken(data?.appToken)
        setExpiresIn(data?.appToken)
        this.token = data?.appToken
      }
    },
    changeHeaderPopup() {
      this.showHeaderPopup = !this.showHeaderPopup
    },
    openHeaderPopup() {
      this.showHeaderPopup = true
    },
    closeHeaderPopup() {
      this.showHeaderPopup = false
    },
    async setAuthExchange(data: any) {
      try {
        const res: any = await authExchangeApi(data)

        setToken(res.data?.accessToken)
        setExpiresIn(res.data?.expireIn)
        this.token = res.data?.accessToken
        this.regChannel = res.data?.regChannel
        // 加这个逻辑是为了防止他在其他站退出，回来之后刷新页面无法同步刷新账号信息
        const { resetUser } = useMyUserStore()
        resetUser()

        if (res.data?.refreshToken) {
          const newTimestamp = new Date().getTime() + res.data?.expireIn * 1000
          setRefreshToken(res.data?.refreshToken)
          setExpiresTimeIn(newTimestamp)
        }
      } catch (error) {
        throw new Error(error + '获取exchange信息失败')
      }
    },

    async logout() {
      try {
        await logoutApi()
      } catch (error) {
        console.log('logoutApi failed', error)
      } finally {
        // 与互踢/401 清态一致：token + 用户/公司信息一并清干净
        clearLocalAuthState()
      }
    },

    changeHeaderIsWhite(isWhite: boolean) {
      this.headerIsWhite = isWhite
    },

    changeNoHeader(show: boolean) {
      this.noHeader = show || this.isAPP
    },

    changeAppFlag(flag: boolean) {
      this.isAPP = flag
    },

    setLanguage(language: string) {
      setCurrentLanguage(language)
      this.language = language
    },

    setProxyApi(proxyApi: string) {
      this.proxyApi = proxyApi
    },

    setTargetPageCode(pageCode: string) {
      this.targetPageCode = pageCode
    },
  },
})
